<template>
  <div class="container" :class="{ 'container-reverse': reverse }">
    <div class="section">
      <router-link
        :to="{
          name: 'capsule',
          params: { name: capsule.title, projectId: capsule._id }
        }"
      >
        <div
          class="card is-horizontal columns is-block-mobile"
          :class="{ 'card--reverse-order': reverse }"
        >
          <div class="card-image column is-6 is-paddingless">
            <figure class="image">
              <img :src="capsule.mainImage[0].fileUrl" />
              <div class="field is-overlay" v-if="capsule.topic">
                <div class="control">
                  <span class="tag is-dark has-text-weight-bold is-size-7">{{
                    capsule.topic
                  }}</span>
                </div>
              </div>
            </figure>
          </div>
          <div class="card-content column">
            <div class="media">
              <div class="media-content">
                <p class="title is-4 has-text-primary">{{ capsule.title }}</p>
                <i18n path="Capsule.partner_path" tag="span" class="is-size-6">
                  <span class="has-text-grey">{{
                    $t("Capsule.supported_by")
                  }}</span>
                  <a
                    class="is-6 has-text-havelock-blue"
                    :href="capsulePartner['partner-url']"
                    @click.stop
                    target="_blank"
                  >
                    {{ capsulePartner.title }}
                  </a>
                </i18n>

                <p class="is-6 has-text-grey">{{ capsule.courses }}</p>
              </div>
            </div>
            <hr />
            <div class="content">
              <p
                class="is-size-6 has-text-left has-text-grey"
                v-html="capsule.shortDescription"
              ></p>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CapsulePartner from '@/components/CapsulePartner'
import { compact } from 'underscore'
export default {
  props: {
    capsule: { default: {} },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  components: { CapsulePartner },
  data () {
    return {
      activeImage: ''
    }
  },
  methods: {
    ...mapActions(['getCapsuleFiles'])
  },
  watch: {
    capsule (newState) {
      this.activeImage = ''
      if (newState.mainImage) {
        this.getCapsuleFiles({ data: { id: [newState.mainImage[0].id] } }).then(
          result => {
            let files = compact(result.data)
            this.activeImage = files.length && files[0].fileUrl
          }
        )
      } else {
        this.activeImage = ''
      }
    }
  },
  computed: {
    capsulePartner () {
      return this.$store.getters.capsulePartner(this.capsule._id)
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  .section {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .container-reverse {
    margin-left: 20px !important;
    margin-right: 0 !important;
  }
}
</style>
<style scoped lang="sass">
.section
  padding: 2rem
hr
  margin: 0.75rem 0

.container
  margin-left: 20px

.title
  margin-top: 0.75rem !important
  margin-bottom: 5px !important

.field
  margin: 1rem

.container-reverse
  margin-left: auto
  margin-right: 20px
.card
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.5)
  .media:not(:last-child)
    margin-bottom: 0.75rem
  &.card--reverse-order
    flex-direction: row-reverse
  &.is-horizontal
    display: flex
    flex-basis: 50ex
    flex-grow: 0
    flex-shrink: 1
    .card-image
      //flex: 4
      flex-shrink: 1
      .image
        display: block
        position: relative
        overflow: hidden
        height: 100%
        width: 100%
        img
          height: 100%
          object-fit: cover
          object-position: center

    .card-content
      padding: 2rem

      .content
        margin: 0
      .card-footer
        bottom: 0.75rem
        position: absolute
        border-top: unset

  @media screen and (max-width: 768px)
    .card
      height: auto
    .media:not(:last-child)
</style>
